import { url } from './http'
const API_URL = "login"

/**
 * @class AuthAPI - Class to handle the authentication API
 */
class AuthAPI {

  /**
   * @function login - Login the user and return the tokens if the credentials are correct
   * @param {string} email - The email of the user
   * @param {string} password - The password of the user
   * @returns {Promise} - The promise of the request
   */
  async login(email, password) {

    // `kind` permite a la vista distinguir credenciales inválidas de fallos de servidor o de red
    const fail = (kind) => Object.assign(new Error(`login ${kind}`), { kind })

    let response
    try {
      response = await fetch(url(API_URL), {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        body: JSON.stringify({ username: email, password: password })
      })
    } catch (e) {
      throw fail('network')
    }
    // Solo 400/401/403/422 significan "credenciales inválidas"; 429 es límite de intentos y
    // el resto de fallos (5xx, 408, proxy/WAF) no dicen nada sobre la contraseña.
    if (response.status === 429) throw fail('throttled')
    if (response.status >= 500 || (response.status >= 400 && ![400, 401, 403, 422].includes(response.status))) {
      throw fail('server')
    }

    let data = null
    let parsed = true
    try {
      data = (await response.json()).data
    } catch (e) {
      parsed = false // cuerpo vacío o no JSON
    }
    if (response.ok && !parsed) throw fail('server')

    if (data && data.token) {
      localStorage.setItem("user", JSON.stringify(data))
      return data
    }

    throw fail('credentials')

  }

  /**
   * @function logout - Logout the user. Remove the user from the local storage
   */
  logout() {
    localStorage.removeItem("user")
  }

}

export default new AuthAPI()